import { BillSearchRequest, PaymentBillSource } from './payment.model';

export class SearchBill {
  static readonly type = '[Payment] Search Bill';
  constructor(public payload: BillSearchRequest) {}
}

export class SearchBillSuccess {
  static readonly type = '[Payment] Search Bill Success';
  constructor(public payload: any) {}
}

export class SearchBillFailure {
  static readonly type = '[Payment] Search Bill Failure';
  constructor(public payload: string) {}
}

export class ProceedCustomPayment {
  static readonly type = '[Payment] Proceed Custom Payment';
  constructor(
    public payload: {
      dataKey: string;
      nameUnderCard: string;
      amount: string;
      billId: string;
      source: PaymentBillSource;
      payerId?: string;
    }
  ) {}
}

export class ProceedCustomPaymentSuccess {
  static readonly type = '[Payment] Proceed Custom Payment Success';
  constructor(public payload: any) {}
}

export class ProceedCustomPaymentFailure {
  static readonly type = '[Payment] Proceed Custom Payment Failure';
  constructor(public payload: any) {}
}

export class ClearPaymentState {
  static readonly type = '[Payment] Clear Payment State';
}
